export default {"src":"/_next/static/media/college1.be4a5d84.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};